const contentid={1:"SCORM",2:"FILE",3:"TEXT",4:"PDF",5:"LINK",6:"HEADING",7:"QUIZ"}

export const getContentid = (id) => {
    return contentid[id] || "Unknown"; // Default to "Unknown" if the ID is not found
  };